export * from './app.component';
export * from './app.module';


// WEBPACK FOOTER //
// ./client/app/index.ts